import React from 'react';

// Datum-Anzeige unter TEF Dashboard
export function MenuDateDisplay() {
  const [time, setTime] = React.useState(new Date());

  React.useEffect(() => {
    const interval = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(interval);
  }, []);

  const formatDate = () => {
    const options = { weekday: 'long', day: '2-digit', month: 'long', year: 'numeric' };
    return time.toLocaleDateString('de-DE', options);
  };

  return (
    <div className="menu-header-date-wrapper">
      <div className="menu-header-date">
        <svg className="date-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
          <line x1="16" y1="2" x2="16" y2="6" />
          <line x1="8" y1="2" x2="8" y2="6" />
          <line x1="3" y1="10" x2="21" y2="10" />
        </svg>
        <span className="date-text">{formatDate()}</span>
        <span className="date-separator">·</span>
        <svg className="date-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
        </svg>
        <span className="date-text">KW {getIsoWeek(time)}</span>
      </div>
      <span className="menu-clock-under-date" style={{fontSize: '7px', fontWeight: 700, display: 'inline-flex', alignItems: 'center', gap: '3px'}}>
        <svg className="clock-icon" style={{width: '12px', height: '12px', minWidth: '12px', stroke: '#22d3ee', filter: 'drop-shadow(0 0 3px rgba(34,211,238,.7))'}} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" />
          <polyline points="12 6 12 12 16 14" />
        </svg>
        {time.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit', second: '2-digit' })}
      </span>
    </div>
  );
}

// Kalenderwochen-Berechnung
export function getIsoWeek(date) {
  const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  const dayNum = d.getUTCDay() || 7;
  d.setUTCDate(d.getUTCDate() + 4 - dayNum);
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  const weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
  return weekNo;
}

// Silvester Countdown Komponente
export function SilvesterCountdown() {
  const [timeLeft, setTimeLeft] = React.useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });

  React.useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date();
      const currentYear = now.getFullYear();
      const newYear = new Date(currentYear + 1, 0, 1, 0, 0, 0);
      const diff = newYear - now;

      if (diff > 0) {
        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((diff % (1000 * 60)) / 1000);
        setTimeLeft({ days, hours, minutes, seconds });
      } else {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      }
    };

    calculateTimeLeft();
    const interval = setInterval(calculateTimeLeft, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="silvester-countdown">
      <div className="countdown-label">🎆 Countdown bis {new Date().getFullYear() + 1}</div>
      <div className="countdown-timer">
        <div className="countdown-segment">
          <span className="countdown-value">{String(timeLeft.days).padStart(2, '0')}</span>
          <span className="countdown-unit">Tage</span>
        </div>
        <span className="countdown-separator">:</span>
        <div className="countdown-segment">
          <span className="countdown-value">{String(timeLeft.hours).padStart(2, '0')}</span>
          <span className="countdown-unit">Std</span>
        </div>
        <span className="countdown-separator">:</span>
        <div className="countdown-segment">
          <span className="countdown-value">{String(timeLeft.minutes).padStart(2, '0')}</span>
          <span className="countdown-unit">Min</span>
        </div>
        <span className="countdown-separator">:</span>
        <div className="countdown-segment">
          <span className="countdown-value">{String(timeLeft.seconds).padStart(2, '0')}</span>
          <span className="countdown-unit">Sek</span>
        </div>
      </div>
    </div>
  );
}

// Mini Countdown für Header - unter Dashboard
export function CountdownMini() {
  const [timeLeft, setTimeLeft] = React.useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });

  React.useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date();
      const currentYear = now.getFullYear();
      const newYear = new Date(currentYear + 1, 0, 1, 0, 0, 0);
      const diff = newYear - now;

      if (diff > 0) {
        setTimeLeft({
          days: Math.floor(diff / (1000 * 60 * 60 * 24)),
          hours: Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes: Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((diff % (1000 * 60)) / 1000)
        });
      }
    };

    calculateTimeLeft();
    const interval = setInterval(calculateTimeLeft, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="countdown-mini">
      <div className="countdown-mini-header">
        <svg className="countdown-mini-icon" viewBox="0 0 24 24" width="14" height="14">
          <circle cx="12" cy="12" r="2" fill="#00ffd5" />
          <path d="M12 2v3M12 19v3M2 12h3M19 12h3" stroke="#00ffd5" strokeWidth="2" strokeLinecap="round" />
          <path d="M5.64 5.64l2.12 2.12M16.24 16.24l2.12 2.12M5.64 18.36l2.12-2.12M16.24 7.76l2.12-2.12" stroke="#00ffd5" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
        <span className="countdown-mini-year">{new Date().getFullYear() + 1}</span>
      </div>
      <div className="countdown-mini-blocks">
        <div className="countdown-mini-block">
          <span className="countdown-mini-num">{String(timeLeft.days).padStart(2, '0')}</span>
          <span className="countdown-mini-label">Tage</span>
        </div>
        <span className="countdown-mini-sep">:</span>
        <div className="countdown-mini-block">
          <span className="countdown-mini-num">{String(timeLeft.hours).padStart(2, '0')}</span>
          <span className="countdown-mini-label">Std</span>
        </div>
        <span className="countdown-mini-sep">:</span>
        <div className="countdown-mini-block">
          <span className="countdown-mini-num">{String(timeLeft.minutes).padStart(2, '0')}</span>
          <span className="countdown-mini-label">Min</span>
        </div>
        <span className="countdown-mini-sep">:</span>
        <div className="countdown-mini-block">
          <span className="countdown-mini-num">{String(timeLeft.seconds).padStart(2, '0')}</span>
          <span className="countdown-mini-label">Sek</span>
        </div>
      </div>
    </div>
  );
}
